import { createAction, handleActions } from 'redux-actions'
import { LOCATION_CHANGE } from 'react-router-redux'

export const ERROR = 'root/ERROR'
export const START = 'root/START'
export const FINISH = 'root/FINISH'
export const TITLE = 'root/TITLE'
export const BANNER = 'root/BANNER'
export const INITIAL_LOAD = 'root/INITIAL_LOAD'
export const TRACK_ANALYTICS_EVENT = 'root/ANALYTICS_TRACKED_EVENT'


export const loadStart = createAction(START)
export const loadFinish = createAction(FINISH)
export const loadError = createAction(ERROR, msg => (
    typeof msg === 'string' ?
    { error: {code: -1, msg: msg}}
    : msg
))
const loadTitle = createAction(TITLE)
const loadBanner = createAction(BANNER)
const initialLoad = createAction(INITIAL_LOAD)
export const trackAnalyticsEvent = createAction(TRACK_ANALYTICS_EVENT)


export function setTitle(title, name=null) {
  return dispatch => {
    dispatch(loadTitle({title, name}))
  }
}

export function setBanner(banner) {
  return dispatch => {
    dispatch(loadBanner({banner:banner}))
  }
}

export function setInfoBanner(content) {
  return dispatch => {
    dispatch(loadBanner({infoBanner:content}))
  }
}

export function setAgreementBanner(banner) {
  return dispatch => {
    dispatch(loadBanner({agreementBanner:banner}))
  }
}

export function setWhiteBanner(white_banner) {
  return dispatch => {
    dispatch(loadBanner({whiteBanner:white_banner}))
  }
}

export function setItemOnInitialLoad(item) {
  return dispatch =>  {
    dispatch(initialLoad({...item}))
  }
}

const initialState = {
    isLoading: false,
    error: null,
}

export default handleActions({
    [LOCATION_CHANGE]: (state) => ({
        ...initialState
    }),
    [START]: (state) => ({
        ...state,
        isLoading: true,
        error: null,
    }),
    [FINISH]: (state) => ({
        ...state,
        ...initialState
    }),
    [ERROR]: (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload
    }),
    [TITLE]: (state, { payload }) => ({
        ...state, ...payload
    }),
    [BANNER]: (state, { payload }) => ({
        ...state, ...payload
    }),
    [INITIAL_LOAD]: (state, { payload }) => ({
        ...state,
        infoForSegment: payload
    }),
}, initialState)
